(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("harriLayoutContainer", {
            controller: HarriLayoutContainerComponent,
            bindings: {},
            controllerAs: '$ctrl',
            templateUrl: '../hmodules/harri-main/containers/harri-layout/harri-layout.container.html'
        });

    HarriLayoutContainerComponent.$inject = ['$scope', 'hUser', '$state', 'appLayoutViewService', 'genAiService' , 'useGenAiVisibility'];

    function HarriLayoutContainerComponent($scope, hUser, $state, appLayoutViewService, genAiService , useGenAiVisibility) {

        const self = this;
        let isSalliActivated = false;
        const { isSalliEnabled } = useGenAiVisibility();
        self.searchOpen = false;

        const isTeamScheduleUser = EnvironmentsConfig.getEnv().host === EnvironmentsConfig.TEAM_SCHEDULE;

        const brandsListUpdatedEvent = !isTeamScheduleUser && hUser.onBrandsListUpdated(() => {
            init();
        });

        self.canViewSalli = () => {
            return $state.current.name.startsWith('appLayout.schedule.main') && isSalliActivated;
        }

        self.toggleSalli = () => {
            genAiService.toggleSalliSideBar();
        }

        self.onSearchOpen = function (isShown) {
            self.searchOpen = isShown;
            $scope.$evalAsync();
        };

        const init = () => {
            self.isEmployer = hUser.isEmployer();
            if (self.isEmployer) {
                appLayoutViewService.updateBrandTheme()
                    .finally(() => {
                        $scope.$evalAsync();
                    });

                if (!hUser.isTopLevelContext()) {
                    isSalliEnabled(hUser.getActiveBrandIdWithAccess())
                        .then((enabled) => {
                            isSalliActivated = enabled;
                            $scope.$digest();
                        });
                }

            }
        };

        self.$onInit = function () {
            init();
        };

        self.checkIfHasNavBarMenu = function () {
            return appLayoutViewService.checkIfHasNavBarMenu();
        };

        self.isSideBarExpanded = function () {
            return appLayoutViewService.isSideBarExpanded();
        };

        self.getToggleSource = function () {
            return appLayoutViewService.getToggleSource();
        };

        self.$onDestroy = function () {
            brandsListUpdatedEvent && hUser.off(brandsListUpdatedEvent);
        };
    }
})();
